import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=46e2bcd6&"
import script from "./UpdatePassword.vue?vue&type=script&lang=js&"
export * from "./UpdatePassword.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports